import { TnAWorkedTimeDTO, TnAWorkedTimeSTO } from "../../models/tna-worked-time";
import { BaseApiService } from "../base/base-api.service";

export class TnAWorkedTimesApiService extends BaseApiService<TnAWorkedTimeDTO, TnAWorkedTimeSTO> {
  constructor() {
    super({
      servicePath: "/TnAOverviews",
      loadItemsPath: "/GetTnAWorkedTimes",
    });
  }
}
